import { HttpInterceptorFn } from '@angular/common/http';

export const TimezoneInterceptor: HttpInterceptorFn = (request, next) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const modifiedRequest = request.clone({
    setHeaders: {
      'X-Timezone': timezone,
    },
  });

  return next(modifiedRequest);
};

